module.exports = __webpack_public_path__ + "media/app/assets/races/night_elf_male-4509f2d5e132700779a133a5e1fc1ce0.png";